import { render, staticRenderFns } from "./AdminReportsDetention.vue?vue&type=template&id=0c815805&scoped=true&"
import script from "./AdminReportsDetention.vue?vue&type=script&lang=ts&"
export * from "./AdminReportsDetention.vue?vue&type=script&lang=ts&"
import style0 from "./AdminReportsDetention.vue?vue&type=style&index=0&id=0c815805&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c815805",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
